export default __webpack_public_path__ + "static/media/UN_Goal_15.4318504a.png";